var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAnchor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510.003 510.003",
    height: 512,
    viewBox: "0 0 510.003 510.003",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ca1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#537983"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.001,
    x2: 255.001,
    xlinkHref: "#lg1",
    y1: 122.087,
    y2: 174.96
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.527,
    x2: 160.277,
    xlinkHref: "#lg2",
    y1: 158.493,
    y2: 130.243
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.527,
    x2: 278.277,
    xlinkHref: "#lg2",
    y1: 158.493,
    y2: 130.243
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.052,
    x2: 321.802,
    xlinkHref: "#lg2",
    y1: 157.197,
    y2: 128.947
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.165,
    x2: 193.606,
    xlinkHref: "#lg1",
    y1: 138.82,
    y2: 138.82
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.695,
    x2: 359.136,
    xlinkHref: "#lg1",
    y1: 138.82,
    y2: 138.82
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.343,
    x2: 380.695,
    xlinkHref: "#lg1",
    y1: 240.698,
    y2: 546.154
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.568,
    x2: 174.568,
    xlinkHref: "#lg2",
    y1: 317.918,
    y2: 279.918
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.001,
    x2: 255.001,
    xlinkHref: "#lg2",
    y1: 319.13,
    y2: 563.162
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.001,
    x2: 255.001,
    xlinkHref: "#lg2",
    y1: 194.001,
    y2: 118.442
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.001,
    x2: 255.001,
    xlinkHref: "#lg1",
    y1: 53.791,
    y2: 157.698
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(-1 0 0 -1 -553.997 -3056.937)",
    gradientUnits: "userSpaceOnUse",
    x1: -808.999,
    x2: -808.999,
    xlinkHref: "#lg1",
    y1: -3134.575,
    y2: -3058.149
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.603,
    x2: 262.603,
    xlinkHref: "#lg2",
    y1: 308.995,
    y2: 245.328
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 244.267,
    x2: 217.6,
    xlinkHref: "#lg3",
    y1: 154.543,
    y2: 257.876
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.469,
    x2: 300.969,
    xlinkHref: "#lg2",
    y1: 97.281,
    y2: 50.531
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.177,
    x2: 313.177,
    xlinkHref: "#lg3",
    y1: 23.335,
    y2: 92.385
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m352.593 163.552h-195.183c-13.659 0-24.732-11.073-24.732-24.732 0-13.659 11.073-24.732 24.732-24.732h195.183c13.659 0 24.732 11.073 24.732 24.732 0 13.659-11.073 24.732-24.732 24.732z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.236 163.552h60.307l-49.464-49.465h-10.843z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.237 163.552h60.307l-49.465-49.465h-10.842z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.894 143.402-29.315-29.315h-10.842v49.465h15.858c12.092-.001 22.15-8.682 24.299-20.15z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m173.145 168.41h-1.818c-6.954 0-12.591-5.637-12.591-12.591v-34c0-6.954 5.637-12.591 12.591-12.591h1.818c6.954 0 12.591 5.637 12.591 12.591v34c0 6.954-5.637 12.591-12.591 12.591z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.675 168.41h-1.818c-6.954 0-12.591-5.637-12.591-12.591v-34c0-6.954 5.637-12.591 12.591-12.591h1.818c6.954 0 12.591 5.637 12.591 12.591v34c0 6.954-5.637 12.591-12.591 12.591z",
    fill: "url(#SVGID_6_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m505.601 277.984-48.518-73.513c-10.411-15.774-33.555-15.774-43.966 0l-48.518 73.513c-11.558 17.512 1.001 40.848 21.983 40.848h1.891c-3.563 9.794-8.157 19.094-13.679 27.747-21.352 33.459-73.242 18.144-73.242-21.547v-215.03h-93.102v215.03c0 39.691-51.89 55.006-73.242 21.547-5.522-8.653-10.116-17.952-13.679-27.747h1.891c20.982 0 33.541-23.336 21.983-40.848l-48.518-73.513c-10.411-15.774-33.555-15.774-43.966 0l-48.517 73.513c-11.558 17.512 1.001 40.848 21.983 40.848h10.926c19.832 89.362 93.269 158.549 184.846 172.067 6.08.898 11.502 4.309 14.888 9.438 8.504 12.885 27.41 12.885 35.915 0 3.385-5.13 8.808-8.541 14.888-9.438 91.576-13.518 165.013-82.705 184.846-172.067h10.926c20.98 0 33.539-23.337 21.981-40.848z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.083 204.471c-10.411-15.774-33.555-15.774-43.966 0l-48.518 73.513c-11.558 17.511 1.001 40.848 21.983 40.848h1.891c-3.563 9.794-8.157 19.094-13.679 27.747-21.352 33.459-73.242 18.144-73.242-21.547v-215.03h-46.551v400c6.853 0 13.705-3.221 17.957-9.664 3.385-5.13 8.808-8.541 14.888-9.438 91.576-13.519 165.013-82.705 184.846-172.067h10.926c20.982 0 33.541-23.336 21.983-40.848z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m483.621 318.83h-10.93c-19.83 89.36-93.27 158.55-184.84 172.07-6.08.9-11.51 4.31-14.89 9.44-8.51 12.88-27.41 12.88-35.92 0-3.38-5.13-8.81-8.54-14.89-9.44-91.57-13.52-165.01-82.71-184.84-172.07h-10.93c-20.98 0-33.54-23.33-21.98-40.85l48.52-73.51c4.6-6.97 11.7-10.87 19.09-11.67-.01 30.82-.01 69.32-.01 69.99 0 91.96 67.83 168.07 156.18 181.05 4.94.72 9.33 3.55 12.08 7.72 3.49 5.29 9.12 7.93 14.74 7.93s11.25-2.64 14.74-7.93c1.38-2.09 3.16-3.83 5.22-5.15s4.39-2.21 6.86-2.57c88.35-12.98 156.18-89.09 156.18-181.05 0-.67 0-39.17-.01-69.99 7.39.8 14.49 4.7 19.09 11.67l48.52 73.51c11.56 17.52-1 40.85-21.98 40.85z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m301.553 110.001h-93.103v6.451l93.103 93.102z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.001.001c-37.3 0-67.53 30.23-67.53 67.53 0 37.29 30.23 67.53 67.53 67.53s67.53-30.24 67.53-67.53c0-37.3-30.23-67.53-67.53-67.53zm0 96.18c-15.83 0-28.65-12.83-28.65-28.65 0-15.83 12.82-28.66 28.65-28.66s28.65 12.83 28.65 28.66c0 15.82-12.82 28.65-28.65 28.65z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.001 117.201c27.43 0 49.67-22.24 49.67-49.67s-22.24-49.67-49.67-49.67-49.67 22.24-49.67 49.67 22.24 49.67 49.67 49.67zm0-78.32c15.83 0 28.65 12.83 28.65 28.65 0 15.83-12.82 28.66-28.65 28.66s-28.65-12.83-28.65-28.66c0-15.82 12.82-28.65 28.65-28.65z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.553 325.031v-83.03h-93.103v5.962l100.468 100.469c-4.564-6.283-7.365-14.183-7.365-23.401z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.551 224.871c27.64 5.01 53.59 16.36 76.12 33.3l-13.07 19.81c-2.34 3.55-3.69 7.33-4.18 11.11-17.34-13.93-37.39-23.61-58.87-28.5-10.66-2.42-21.67-3.67-32.87-3.67-4.58 0-9.14-.15-13.68-.45-22.52-1.47-44.48-6.6-65.48-15.3-25.22-10.45-47.8-25.53-67.1-44.84-18.23-18.23-28.27-42.47-28.27-68.25s10.04-50.02 28.27-68.25l13.34-13.34c17.3-17.3 41.75-23.21 63.94-17.72-6.73 9.57-11.03 20.97-12.01 33.3-9.66-1.29-19.79 1.77-27.19 9.17l-13.33 13.34c-11.62 11.62-18.02 27.07-18.02 43.5 0 16.44 6.4 31.88 18.02 43.5 29.2 29.21 67.08 46.62 107.83 49.8 4.53.36 9.09.54 13.68.54 11.14 0 22.13 1 32.87 2.95z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.651 67.531c0 15.82-12.82 28.65-28.65 28.65v38.88c37.3 0 67.53-30.24 67.53-67.53 0-2.805-.191-5.564-.523-8.28h-39.575c.789 2.622 1.218 5.401 1.218 8.28z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.871 93.371c-6.83 6.84-17.91 6.84-24.74 0l-22.43-22.42c-6.96-6.96-16.32-10.08-25.43-9.36-7.43.57-14.69 3.69-20.37 9.36l-.3.29c-7.56 7.56-16.47 12.94-25.96 16.15-13.03 4.41-27.15 4.72-40.33.94-5.52-5.21-8.96-12.61-8.96-20.8 0-7.22 2.68-13.83 7.1-18.87 5.77 4.74 12.94 7.32 20.5 7.32 8.09 0 15.73-2.95 21.68-8.33.42-.38.82-.76 1.22-1.16l.3-.29c9.32-9.33 20.72-15.34 32.72-18.04 21.82-4.92 45.63 1.09 62.58 18.04l22.43 22.43c6.83 6.83 6.83 17.91-.01 24.74z",
    fill: "url(#SVGID_16_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnchor);
export default __webpack_public_path__ + "static/media/icon-anchor.8d63fe059438d7830bc8fa935c132673.svg";
export { ForwardRef as ReactComponent };